var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-shortcut-window-outline",class:{ 'active': _vm.isActive, 'show': _vm.show },style:(_vm.style)},[_c('div',{staticClass:"modal-shortcut-id"},[_vm._v(_vm._s(_vm.shortcutHint.shortcutId))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b1a488","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/home/_components/tombola-shortcut-overlay/_components/shortcut-overlay-item/shortcut-overlay-item.html
// module id = null
// module chunks = 